//
// Copyright (c) 2024 Comcast
//

import styled from 'styled-components'

import colors from 'components/utils/colors'

const StyledEnvironmentStripe = styled.div`
  position: absolute;
  height: 4px;
  width: 100%;
  background: ${props => props.$stripeColor};
`

export const getEnvironmentStripeInfo = () => {
  const userIsAdmin = Boolean(localStorage.getItem('user_is_admin') === 'true')

  const isProduction = Boolean(process.env.RELEASE_STAGE.includes('production'))
  const isStaging = Boolean(process.env.RELEASE_STAGE.includes('staging') || process.env.RELEASE_STAGE.includes('preprod'))

  const stripeColor = isProduction ? colors.alert75 : colors.warning60
  const showStripe = userIsAdmin && (isProduction || isStaging)

  return ({
    isVisible: showStripe,
    isProduction: isProduction,
    isStaging: isStaging,
    stripeColor: stripeColor,
  })
}

const EnvironmentStripe = ({ className }) => {
  const { isVisible, stripeColor } = getEnvironmentStripeInfo()

  if (!isVisible) {
    return null
  }

  return (
    <StyledEnvironmentStripe
      $stripeColor={stripeColor}
      className={className}
    />
  )
}

export default EnvironmentStripe
